import { render, staticRenderFns } from "./MultipleCategorySelectInputWidget.vue?vue&type=template&id=7cfefcdc&scoped=true"
import script from "./MultipleCategorySelectInputWidget.vue?vue&type=script&lang=js"
export * from "./MultipleCategorySelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfefcdc",
  null
  
)

export default component.exports